import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IBereichsResponse } from 'fa-kt.types';
import { PostBereichCommandService } from '../commands';
import { BereichsService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class BereichsPageResolver implements Resolve<IBereichsResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private bereichs: BereichsService,
    private postBereich: PostBereichCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IBereichsResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [bereichs] = await Promise.all([this.bereichs.request({}).catch(log), this.postBereich.prepare(true).catch(log)]);
    this.loading.resolved();
    return bereichs;
  }
}
